

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import store from './store'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {browserMobile} from './common/js/util'
import VueClipboards from 'vue-clipboard2'

Vue.use(VueClipboards);




Vue.directive('transfer-dom', TransferDom)

Vue.use(VueRouter)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
loading: require('@/common/image/default_image_normal.png'),
error: require('@/common/image/default_image_normal.png')
})


import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)

FastClick.attach(document.body)
Vue.config.productionTip = false


router.afterEach((to, from) => {
console.log(new Date())

if(browserMobile().isPc){
window.open(window.location.origin+'/index.html','_self')
}

var _hmt = _hmt || [];
(function() {
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?26c3b4a3eb651f6cf93b307c1d58fceb";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);

})();


})


/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js